<template>
  <el-dialog
      :close-on-click-modal="false" title="抵质押详情" :visible.sync="verificationVisible" width="50%">
    <div>
      <a-spin :spinning="spinning">
        <a-descriptions
          bordered
          title=""
          size="small"
          layout="horizontal"
          :column="2"
        >
          <a-descriptions-item label="物品名称">
            <div class="width_div">
              {{ data.leaseName }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="抵押或质押">
            <div class="width_div">
              {{ data.isCollateral==1?'抵押': data.isCollateral==2?'质押':'' }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="抵质押物类型">
            <div class="width_div">
              {{ data.collateralType }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="型号规格">
            <div class="width_div">
              {{ data.model }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="数量">
            <div class="width_div">
              {{ data.number }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="发票号">
            <div class="width_div">
              {{ data.invoiceNo }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="购置时间">
            <div class="width_div">
              {{ data.purchasingDate }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="生产厂商或供应商">
            <div class="width_div">
              {{ data.manufacturerName }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="抵质押权人">
            {{ data.collateralPowerPerson }}
          </a-descriptions-item>
          <a-descriptions-item label="抵押人">
            {{ data.collateralPerson }}
          </a-descriptions-item>
          <a-descriptions-item label="原值总价(含税)">
            {{ data.totalIncludingTax }}
          </a-descriptions-item>
          <a-descriptions-item label="原值总价(扣税)">
            {{ data.totalExclusiveTax }}
          </a-descriptions-item>
          <a-descriptions-item label="备注" :span="2">
            {{ data.remarks }}
          </a-descriptions-item>
        </a-descriptions>
      </a-spin>
    </div>
  </el-dialog>
</template>

<script>
import * as api from "@/api/factoring/factoring";

export default {
  data() {
    return {
      verificationVisible: false,
      data: {},
      id: "",
      spinning: true,
    };
  },
  components: {},

  created() {},
  methods: {
    showblock(id) {
      this.verificationVisible = true;

      this.id = id;
      api.getCollateralDetail({ id: id }).then((res) => {
        let data = res.data.data;
         
        this.data = data;
        this.spinning=false
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.width_div {
  width: 120px;
}
/deep/.el-dialog__body {
  padding: 15px 20px 30px;
}
/deep/.el-dialog {
  max-height: 600px;
  overflow-y: scroll;
}
</style>